/**
 * Created by camiel on 21/04/2017.
 */

import Bitmap = createjs.Bitmap;
import Container = createjs.Container;
import LoadQueue = createjs.LoadQueue;
import Tween = createjs.Tween;

import AssetManager from "lib/src/AssetManager";
import Native from "lib/src/Native";

import IColorOffset from "src/IColorOffset";
import {
  isWhiteKey,
  KeyboardKeyId,
  keyCodeToKeyId
} from "src/KeyboardSounds";
import {MAIN_COLOR_OFFSET} from "src/constants";
import { throws } from "assert";

const KEY_WHITE_ID = "key-white";
const KEY_BLACK_ID = "key-black";
const KEY_BLACK_BACKGROUND_ID = "key-black-background";

export const KEYBOARD_KEY_WHITE_WIDTH = 151;
export const KEYBOARD_KEY_WHITE_HEIGHT = 676;

export default class KeyboardKey {
  public static addToManifest(manifest: any[]): void {
    const assets = [ KEY_WHITE_ID, KEY_BLACK_ID, KEY_BLACK_BACKGROUND_ID ];

    assets
      .map((id) => ({
        id,
        src: AssetManager.getShared(`${id}.png`),
      }))
      .forEach((asset) => manifest.push(asset));
  }

  public readonly container: Container;
  private readonly _keyboardKeyContainer: Container;

  private _keyboardKeyPressed: Bitmap;

  private fired: boolean;

  constructor(
    private readonly _keyboardKeyId: KeyboardKeyId,
    private readonly _preLoadQueue: LoadQueue,
    private readonly _playSound: (keyboardKeyId: KeyboardKeyId) => void,
    colorOffset: IColorOffset,
    pressedColorOffset: IColorOffset,
  ) {
    this.container = new Container();
    this._keyboardKeyContainer = new Container();

    this._initializeKeyBackground();

    this.container.addChild(this._keyboardKeyContainer);
    this._initializeKey(colorOffset, pressedColorOffset);
    this.fired = false;
  }

  public playSound(): void {
    this._playSound(this._keyboardKeyId);
    this._animateKeyPress();
  }

  public onKeyDown(ev): void {
    if (keyCodeToKeyId(ev.keyCode) == this._keyboardKeyId) {
      console.log(`keyboardKeyId ${this._keyboardKeyId},keycode: ${ev.keyCode} => ${keyCodeToKeyId(ev.keyCode)}`)

      if(!this.fired) {
        this.fired = true;
        this.playSound()
      }
    }
  }

  public onKeyUp(ev): void {
    if (keyCodeToKeyId(ev.keyCode) == this._keyboardKeyId) {
      this.fired = false;
    }
  }

  private _initializeKey(colorOffset: IColorOffset, pressedColorOffset: IColorOffset) {
    const keyboardKeyDefault = this._createKeyboardKey(colorOffset);

    keyboardKeyDefault.on("click", this.playSound.bind(this));

    // TODO:
    // this is very inefficient, because every key has it's own event listener,
    // but it was the easiest fix based on how the code works right now
    // to improve it we could maybe add one event listener at the Keyboard.ts level
    // add keyup/keydown event to window, and find the coresponding key in
    // keyboardKeysContainer and trigger onKey up and onKeyDown on it
    // youd have to track a fired boolean for each key to make sure you 
    // don't trigger them repeateatly.
    window.addEventListener('keydown', this.onKeyDown.bind(this))
    window.addEventListener('keyup', this.onKeyUp.bind(this))

    this._keyboardKeyPressed = this._createKeyboardKey(pressedColorOffset);
    this._keyboardKeyPressed.alpha = 0;
  }

  private _initializeKeyBackground(): void {
    if (!isWhiteKey(this._keyboardKeyId)) {
      const keyBlackBackgroundImage =
        this._preLoadQueue.getResult(KEY_BLACK_BACKGROUND_ID) as HTMLImageElement;

      const keyBlackBackground = new Bitmap(keyBlackBackgroundImage);

      keyBlackBackground.filters = [
        new createjs.ColorFilter(
          0, 0, 0, 1,
          MAIN_COLOR_OFFSET.red,
          MAIN_COLOR_OFFSET.green,
          MAIN_COLOR_OFFSET.blue,
          0,
        ),
      ];

      keyBlackBackground.cache(0, 0, keyBlackBackgroundImage.width, keyBlackBackgroundImage.height);

      keyBlackBackground.regX = keyBlackBackground.image.width / 2;
      keyBlackBackground.regY = 0;

      this.container.addChild(keyBlackBackground);
    }
  }

  private _createKeyboardKey(colorOffset: IColorOffset): Bitmap {
    const keyboardKeyImage = this._keyboardKeyImage;
    const keyboardKey = new Bitmap(keyboardKeyImage);

    keyboardKey.regX = keyboardKey.image.width / 2;
    keyboardKey.regY = 0;

    keyboardKey.filters = [
      new createjs.ColorFilter(0, 0, 0, 1, colorOffset.red, colorOffset.green, colorOffset.blue, 0),
    ];

    keyboardKey.cache(0, 0, keyboardKeyImage.width, keyboardKeyImage.height);

    this._keyboardKeyContainer.addChild(keyboardKey);

    return keyboardKey;
  }

  private get _keyboardKeyImage(): HTMLImageElement {
    if (isWhiteKey(this._keyboardKeyId)) {
      return this._preLoadQueue.getResult(KEY_WHITE_ID) as HTMLImageElement;
    } else {
      return this._preLoadQueue.getResult(KEY_BLACK_ID) as HTMLImageElement;
    }
  }

  private _animateKeyPress(): void {
    Tween
      .get(this._keyboardKeyPressed)
      .to({ alpha: 1 }, 50)
      .wait(150)
      .to({ alpha: 0 }, 50);

    Tween
      .get(this._keyboardKeyContainer)
      .to({ regX: -4, regY: -4 }, 50)
      .wait(150)
      .to({ regX: 0, regY: 0 }, 100);
  }
}



// WEBPACK FOOTER //
// ./src/KeyboardKey.ts